@if (!isFetching) {
    @if (eventPreview) {
        <a [href]="eventPreview.source_url" target="_blank" class="occasion-genius-card"
           [style.background-image]="'url(' + eventPreview.image_url + ')'"
           (click)="handleShowMore($event)"
        >
            @if (!disableHurt) {
                <div class="occasion-genius-card__header">
                    <button class="btn-hurt btn-hurt--circle"
                            [class.active]="favoritesProviderService.isFavorite('occasion_genius', eventPreview.uuid)"
                            (click)="toggleHurt($event)">
                        <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
                    </button>
                </div>
            }
            <div class="occasion-genius-card__content">
                <h4 class="occasion-genius-card__title">
                    {{ eventPreview.name }}
                </h4>
                <div class="occasion-genius-card__info">
                    @if (events.length > 1) {
                        {{ m(events[0].start_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do') }} - {{ m(events[events.length - 1].start_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do') }}
                    } @else {
                        {{ m(eventPreview.start_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do YYYY, h:mmA') }}
                    }
                </div>
            </div>
        </a>
    }
} @else {
    <div class="occasion-genius-card" #geniusCard>
        <ngx-skeleton-loader style="width: 100%;" [theme]="{
      height: geniusCard.clientHeight + 'px',
      margin: 0
    }"></ngx-skeleton-loader>
    </div>
}
